import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import Reveal from "@/components/base/Reveal";
import { allDramas } from "@/lib/drama";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const SCOPE_ITEMS = [
  {
    icon: "ri-film-line",
    title: "剧集资料展示",
    desc: "整理剧名、题材、地区、年份、集数、演职阵容与剧情简介，方便快速了解一部剧。",
  },
  {
    icon: "ri-filter-3-line",
    title: "分类与智能筛选",
    desc: "支持按类型、地区、年份组合筛选，并提供更新时间、热度、评分三种排序方式。",
  },
  {
    icon: "ri-search-line",
    title: "全站关键词搜索",
    desc: "可搜索剧名、演员、导演与题材标签，搜索结果与详情页数据保持完全一致。",
  },
  {
    icon: "ri-heart-3-line",
    title: "本地收藏能力",
    desc: "收藏记录保存在浏览器本地，不需要注册登录，清理浏览器数据后会自动清空。",
  },
];

export default function About() {
  useDocumentMeta({
    title: "关于我们 - 嫂子的职业在线观看",
    description:
      "了解嫂子的职业在线观看网站的定位、内容范围、版权与免责声明。本站为演示站点，仅整理电视剧资料，不提供任何影视资源文件。",
    keywords: "关于我们,嫂子的职业在线观看,网站定位,免责声明,电视剧在线观看",
  });

  return (
    <div className="min-h-screen bg-background-100">
      <SiteHeader />
      <main className="pt-16 md:pt-[72px]">
        <section className="border-b border-background-200 bg-background-50">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-12">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
              <Link to="/" className="transition-colors hover:text-primary-600">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" aria-hidden="true" />
              <span className="text-foreground-800">关于本站</span>
            </nav>
            <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              关于嫂子的职业在线观看
            </h1>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
              一个面向电视剧爱好者的内容整理站点，专注题材分类、剧集资料与找剧体验。
              我们把零散的剧集信息整理成清晰的结构，让你在几分钟内找到想看的那一部。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {[
                { value: `${allDramas.length}`, label: "收录剧集" },
                { value: "7", label: "题材分类" },
                { value: "6", label: "地区覆盖" },
                { value: "100%", label: "资料结构化" },
              ].map((item) => (
                <div key={item.label} className="rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                  <p className="font-heading text-xl font-bold text-primary-700 md:text-2xl">{item.value}</p>
                  <p className="mt-1 text-[11px] text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-12">
          <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-10">
            <div className="min-w-0 space-y-8">
              <Reveal>
                <section aria-labelledby="position-title">
                  <h2 id="position-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    网站定位
                  </h2>
                  <div className="mt-3 space-y-3 text-sm leading-7 text-foreground-700">
                    <p>
                      「嫂子的职业在线观看」是一个以电视剧内容为核心的展示型网站。我们把重心放在
                      <strong className="font-medium text-foreground-900">找剧效率</strong>与
                      <strong className="font-medium text-foreground-900">资料完整度</strong>上：
                      每部剧都有独立详情页，演职信息、题材标签、更新状态与剧情简介一一对应，
                      列表页与详情页使用同一份数据源，不存在信息不一致的情况。
                    </p>
                    <p>
                      我们把都市、职场、情感、悬疑、家庭、年代、励志等常见题材做了结构化整理，
                      并提供组合筛选与热度排序，帮助你在不知道看什么的时候，也能顺着题材脉络找到下一部剧。
                    </p>
                  </div>
                </section>
              </Reveal>

              <Reveal>
                <section aria-labelledby="scope-title">
                  <h2 id="scope-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    内容范围
                  </h2>
                  <div className="mt-4 grid gap-3 sm:grid-cols-2">
                    {SCOPE_ITEMS.map((item) => (
                      <div
                        key={item.title}
                        className="rounded-lg border border-background-200 bg-background-50 p-4"
                      >
                        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                          <i className={`${item.icon} text-lg`} aria-hidden="true" />
                        </span>
                        <h3 className="mt-3 text-sm font-medium text-foreground-900">{item.title}</h3>
                        <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                      </div>
                    ))}
                  </div>
                </section>
              </Reveal>

              <Reveal>
                <section aria-labelledby="disclaimer-title">
                  <h2 id="disclaimer-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    版权声明与免责声明
                  </h2>
                  <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                    <ul className="space-y-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      <li className="flex gap-2">
                        <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true" />
                        <span>
                          本站为<strong className="font-medium text-foreground-900">演示性质</strong>的网站，
                          所有剧集名称、简介、演职人员与评分均为模拟数据，不代表真实作品信息。
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true" />
                        <span>
                          本站<strong className="font-medium text-foreground-900">不存储、不上传、不传播</strong>
                          任何影视资源文件，也不提供任何下载地址或播放源。
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true" />
                        <span>
                          详情页的播放功能仅为前端交互演示，点击后出现的播放器界面不加载任何真实视频内容。
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true" />
                        <span>
                          如需观看真实影视作品，请通过正规授权平台观看，支持正版内容与创作者。
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <i className="ri-shield-check-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true" />
                        <span>
                          收藏数据保存在用户本机浏览器的本地存储中，本站不会收集、上传或共享这些数据。
                        </span>
                      </li>
                    </ul>
                  </div>
                </section>
              </Reveal>
            </div>

            <div className="min-w-0 space-y-4">
              <FeedbackForm />
              <div className="rounded-lg bg-primary-950 p-5">
                <p className="flex items-center gap-2 text-sm font-medium text-background-50">
                  <i className="ri-customer-service-2-line text-accent-400" aria-hidden="true" />
                  其他联系方式
                </p>
                <p className="mt-2 text-xs leading-relaxed text-background-300">
                  如果反馈表单暂时无法使用，也可以通过下方入口先浏览常见问题与分类说明。
                </p>
                <div className="mt-4 flex flex-col gap-2">
                  <Link
                    to="/category"
                    className="flex items-center justify-between rounded-md border border-background-50/20 px-3 py-2 text-xs text-background-100 transition-colors hover:border-accent-400/60 hover:text-accent-300"
                  >
                    浏览电视剧分类
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </Link>
                  <Link
                    to="/search"
                    className="flex items-center justify-between rounded-md border border-background-50/20 px-3 py-2 text-xs text-background-100 transition-colors hover:border-accent-400/60 hover:text-accent-300"
                  >
                    搜索剧集资料
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </Link>
                </div>
                <p className="mt-4 border-t border-background-50/10 pt-3 text-[11px] text-background-400">
                  响应时间：工作日 1-2 天内查看，节假日顺延。
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}